interface ColorPalette {
  variant1: string;
  variant2: string;
  variant3: string;
  variant4: string;
}

interface Palettes {
  blue: ColorPalette;
  gray: ColorPalette;
  green: ColorPalette;
  yellow: ColorPalette;
  red: ColorPalette;
  purple: ColorPalette;
  teal: ColorPalette;
  orange: ColorPalette;
}

export const colorPalettes: Palettes = {
  blue: {
    variant1: "#203647",
    variant2: "#467599",
    variant3: "#7695B8",
    variant4: "#D8E4ED",
  },
  gray: {
    variant1: "#2F2F30",
    variant2: "#525254",
    variant3: "#8C8C8F",
    variant4: "#E1E1E6",
  },
  green: {
    variant1: "#3B4F2A",
    variant2: "#7CB54E",
    variant3: "#97C274",
    variant4: "#E1EDD8",
  },
  yellow: {
    variant1: "#4D4020",
    variant2: "#EBA800",
    variant3: "#F2C246",
    variant4: "#FCEABB",
  },
  red: {
    variant1: "#4D202B",
    variant2: "#B5183F",
    variant3: "#CC5270",
    variant4: "#EBC3CD",
  },
  purple: {
    variant1: "#3A3163",
    variant2: "#5E4FA1",
    variant3: "#ADA5CF",
    variant4: "#D7D3E8",
  },
  teal: {
    variant1: "#204F40",
    variant2: "#67C2A5",
    variant3: "#9ED9C6",
    variant4: "#CEEBE2",
  },
  orange: {
    variant1: "#732007",
    variant2: "#F5805D",
    variant3: "#F7AB94",
    variant4: "#FAD2C5",
  },
};
